var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, when, makeObservable } from 'mobx';
import { runtime } from '../../../../classes/runtime/Runtime';
import { sleep } from '../../../../utils/helper/helper_time';
import { xa } from '../../../../utils/xa/xa';
export class BrowserBot {
    parent;
    manualBotStageWidthHeight; // 340
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get runtime() {
        return this.parent;
    }
    get botStageWidthHeight() {
        if (this.manualBotStageWidthHeight)
            return this.manualBotStageWidthHeight;
        return 1000;
    }
    async saveFontSizeAndExpected() {
        const enableEdit = await when(() => !!this.runtime.streamedPackages.Edit);
        const enableSync = this.runtime.solidBrowserRuntime.app.edit;
    }
    async fetchStageInner() {
        // disable save
        runtime.runtimeSync.isJustSimulating = true;
        console.log('set manualBotStageWidthHeight to 340');
        this.manualBotStageWidthHeight = 340;
        await sleep(4000);
        let stageInnerHtml = '';
        let stageOuterStyle = '';
        let stageInnerStyle = '';
        // let stageOuterHtml = '';
        try {
            stageInnerHtml = document.getElementsByClassName('stage_inner')[0].innerHTML;
            // stageOuterHtml = document.getElementsByClassName('stage_outer')[0].outerHTML;
            stageOuterStyle = document.getElementsByClassName('stage_outer')[0].getAttribute('style') || '';
            stageInnerStyle = document.getElementsByClassName('stage_inner')[0].getAttribute('style') || '';
        }
        catch (e) { }
        await xa.edit.setQuestionLoadHtml({
            stageInnerHtml,
            stageOuterStyle,
            stageInnerStyle,
            question_id: this.runtime.solidBrowserRuntime.app.question.id,
        });
        await xa.edit.setScreenshotDone({ questionId: this.runtime.solidBrowserRuntime.app.question.id });
        console.log('fetchStageInner', stageInnerHtml, stageOuterStyle, stageInnerStyle);
        console.log('Bot task COMPLETED!');
    }
}
__decorate([
    observable
], BrowserBot.prototype, "manualBotStageWidthHeight", void 0);
__decorate([
    action.bound
], BrowserBot.prototype, "saveFontSizeAndExpected", null);
__decorate([
    action.bound
], BrowserBot.prototype, "fetchStageInner", null);
